import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-manager-drivers-dialog',
    templateUrl: './manager-drivers-dialog.component.html',
    styleUrls: ['./manager-drivers-dialog.component.scss'],
    standalone: false
})
export class ManagerDriversDialogComponent implements OnInit {
  isAcura: boolean = false;
  constructor(private dialogRef: MatDialogRef<ManagerDriversDialogComponent>,
    private appService: AppService) { }

  ngOnInit(): void {
    let vehicleData = this.appService.getVehicleData()
    if (vehicleData && vehicleData.make && vehicleData.make == "Acura") {
      this.isAcura = true
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
